import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateCompanyMemberAccessActions as Actions,
  CreateCompanyMemberAccessRequestAction as RequestAction,
} from 'store/ducks/companyMemberAccesses';

export function* createCompanyMemberAccessRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `company-member-accesses`, postData);
    onSuccess && onSuccess();
    notify('success', 'Acesso ao cliente criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
